// extracted by mini-css-extract-plugin
module.exports = {"img":"VideoAvatar_img___0NLR"};